export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL;
export const TRAINER_API_URL = process.env.REACT_APP_TRAINER_API_URL;
export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;
export const SYNC_API_URL = process.env.REACT_APP_SYNC_API_URL;
export const AUTH_APP_URL = process.env.REACT_APP_AUTH_APP_URL;
export const TRAINER_APP_URL = process.env.REACT_APP_TRAINER_APP_URL;
export const ADMIN_APP_URL = process.env.REACT_APP_ADMIN_APP_URL;
